import { GenericApi } from "./generic.api";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IBlogCategory } from "../model/ddb.model";
import { Observable } from "rxjs";
import { createUrl, getPublicRoutesHeaders, queryToParams } from "./api.util";
import { IQueryFilter, QueryResult } from "../model/query.filter.class";
import { IBlog } from "../model/blog.model";

type T = any;

@Injectable()
export class BlogApi extends GenericApi<T> {
	public path = "blog";

	constructor(public httpClient: HttpClient) {
		super(httpClient);
	}

	readonly updateStatus = (id: string): Observable<{ success: boolean }> => {
		return this.httpClient.get<{ success: boolean }>(
			createUrl(this.path, "status", id)
		);
	};

	readonly webList = (query: IQueryFilter): Observable<QueryResult<IBlog>> => {
		return this.httpClient.get<QueryResult<IBlog>>(
			createUrl(this.path, "web", "list"),
			{
				params: queryToParams(query),
				headers: getPublicRoutesHeaders(),
			}
		);
	};

	readonly webGet = (
		id: string
	): Observable<{ data: IBlog; relatedArticles: IBlog[] }> => {
		return this.httpClient.get<{ data: IBlog; relatedArticles: IBlog[] }>(
			createUrl(this.path, "web", id),
			{
				headers: getPublicRoutesHeaders(),
			}
		);
	};

	readonly checkSlug = (slug: string, id : string | null): Observable<{ exists: boolean }> => {
		return this.httpClient.post<{ exists: boolean }>(
			createUrl(this.path, "check-slug"),
			{
				slug: slug,
				id : id
			}
		);
	};
}
